module.exports = __webpack_public_path__ + "static/media/bg_1.47376fa7.jpg";